// extracted by mini-css-extract-plugin
export default {"catalog_item":"style_catalog_item__QQ66L","catalog_item_name":"style_catalog_item_name__fTHYi","catalog_item_img":"style_catalog_item_img__aYPH0"};